export default __webpack_public_path__ + "static/media/BandAids.f4b3220f.png";